import React from 'react';
import { useTheme } from '../hooks/useTheme';
import './ThemeToggle.css';

/**
 * Light/dark switch for the app header.
 *
 * Shows the theme you would get by pressing it, not the one you are in — the
 * icon is an action, not a status. Untouched, the app follows the OS; pressing
 * this pins a choice until it is pressed back.
 */
export const ThemeToggle: React.FC = () => {
  const { resolved, toggle } = useTheme();
  const next = resolved === 'light' ? 'dark' : 'light';

  return (
    <button
      className="theme-toggle"
      type="button"
      onClick={toggle}
      title={`Switch to ${next} theme`}
      aria-label={`Switch to ${next} theme`}
    >
      <span aria-hidden="true">{resolved === 'light' ? '☾' : '☀'}</span>
    </button>
  );
};
